import { cn } from "@/lib/utils";
import { Icon, type IconName } from "./icon";

// Underline tabs, ported from the prototype's tc-styles.css `.tabs`/`.tab`
// (back-office trip-detail tab strip). Optional per-tab count pill.
export interface TabOption<T extends string> {
  value: T;
  label: string;
  icon?: IconName;
  count?: number;
}

export interface TabsProps<T extends string> {
  options: TabOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

export function Tabs<T extends string>({ options, value, onChange }: TabsProps<T>) {
  return (
    <div className="tabs" role="tablist">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={value === o.value}
          className={cn("tab", value === o.value && "active")}
          onClick={() => onChange(o.value)}
        >
          {o.icon && <Icon name={o.icon} size={16} />}
          {o.label}
          {o.count != null && <span className="tab-count">{o.count}</span>}
        </button>
      ))}
    </div>
  );
}
